export class ValidateEmailRequestArgs {
  public email: string = "";
}
